// import React, { useState, useEffect } from "react";
// import "../../components/DashboardModule/MyQuotations.css";
// import UpdateStatusModal from "./UpdateStatusModal";
// import { getSellerMyConfirmOrder } from "../../API/Api";
// import { MoreVertical } from "lucide-react";
// import PendingQuotesDetails from "./PendingQuotesDetails";
// import UploadPO from "./UploadPO";

// const ConfirmOrderSeller = () => {
// 	const [isModalOpen, setIsModalOpen] = useState(false);
// 	const [isUploadPOOpen, setIsUploadPOOpen] = useState(false);
// 	const [orders, setOrders] = useState([]);
// 	const [loading, setLoading] = useState(true);
// 	const [error, setError] = useState(null);
// 	const [selectedEnquiry, setSelectedEnquiry] = useState(null);
// 	const [showDetails, setShowDetails] = useState(false);
// 	const [selectedOrderForUpdate, setSelectedOrderForUpdate] = useState(null);
// 	const [selectedOrderForUpload, setSelectedOrderForUpload] = useState(null);

// 	const fetchOrders = async () => {
// 		try {
// 			const response = await getSellerMyConfirmOrder();
// 			if (response.status && response.data) {
// 				setOrders(response.data);
// 			}
// 		} catch (err) {
// 			setError(err.message || "Failed to fetch orders");
// 		} finally {
// 			setLoading(false);
// 		}
// 	};

// 	useEffect(() => {
// 		fetchOrders();
// 	}, []);

// 	const handleOpenModal = () => {
// 		setIsModalOpen(true);
// 	};

// 	const handleCloseModal = () => {
// 		setIsModalOpen(false);
// 	};

// 	const handleOpenUploadPO = () => {
// 		setIsUploadPOOpen(true);
// 	};

// 	const handleCloseUploadPO = () => {
// 		setIsUploadPOOpen(false);
// 	};

// 	const handleOpenClick = (enquiry) => {
// 		setSelectedEnquiry(enquiry);
// 		setShowDetails(true);
// 	};

// 	const handleBackClick = () => {
// 		setShowDetails(false);
// 	};

// 	const handleUpdateStatusClick = (order) => {
// 		setSelectedOrderForUpdate(order);
// 		setIsModalOpen(true);
// 	};

// 	const handleUploadPOClick = (order) => {
// 		setSelectedOrderForUpload(order);
// 		setIsUploadPOOpen(true);
// 	};

// 	if (loading) {
// 		return <div className="quo-container font-poppins">Loading...</div>;
// 	}

// 	if (error) {
// 		return <div className="quo-container font-poppins">Error: {error}</div>;
// 	}
// 	if (showDetails && selectedEnquiry) {
// 		return (
// 			<PendingQuotesDetails
// 				onBack={handleBackClick}
// 				enquiry={selectedEnquiry}
// 				enquiryId={selectedEnquiry.enquiry_id}
// 			/>
// 		);
// 	}

// 	return (
// 		<div className="quo-container font-poppins">
// 			<div className="quo-header">
// 				<h2 className="quo-title">Confirmed Orders</h2>
// 				<div className="quo-actions"></div>
// 			</div>

// 			<table className="quo-table">
// 				<thead>
// 					<tr>
// 						<th>Order Id</th>
// 						<th>Product Details</th>
// 						<th>Brand Name</th>
// 						<th>Date</th>
// 						<th>Status</th>
// 						<th>Action</th>
// 					</tr>
// 				</thead>
// 				<tbody>
// 					{orders.map((order) => (
// 						<tr key={order.enquiry_id}>
// 							<td>{order.order_id}</td>
// 							<td>
// 								<div className="product-details">
// 									<div className="product-name">
// 										{order.product_details.product_name}
// 									</div>
// 								</div>
// 							</td>
// 							<td>
// 								{order.brands && order.brands.length > 0 ? (
// 									order.brands.map((brand, index) => (
// 										<span key={brand.id}>
// 											{brand.name}
// 											{index < order.brands.length - 1 && ", "}
// 										</span>
// 									))
// 								) : (
// 									"...."
// 								)}
// 							</td>
// 							<td>
// 								{new Date(order.product_details.created_at).toLocaleDateString()}
// 							</td>
// 							<td>{order.tracking_status}</td>
// 							<td>
// 								<div className="quo-action-menu">
// 									<MoreVertical />
// 									<div className="quo-dropdown">
// 										<button
// 											className="text-quo font-poppins"
// 											onClick={() => handleOpenClick(order)}
// 										>
// 											Preview
// 										</button>
// 										<button
// 											className="text-quo font-poppins"
// 											onClick={() => handleUpdateStatusClick(order)}
// 										>
// 											Update Status
// 										</button>
// 										<button
// 											className="text-quo font-poppins"
// 											onClick={() => handleUploadPOClick(order)}
// 										>
// 											Upload PI
// 										</button>
// 									</div>
// 								</div>
// 							</td>
// 						</tr>
// 					))}
// 				</tbody>
// 			</table>

// 			<UpdateStatusModal
// 				isOpen={isModalOpen}
// 				onClose={handleCloseModal}
// 				quotation_id={selectedOrderForUpdate?.quotation_id}
// 				onStatusUpdated={fetchOrders}
// 			/>

// 			<UploadPO
// 				isOpen={isUploadPOOpen}
// 				onClose={handleCloseUploadPO}
// 				order={selectedOrderForUpload}
// 				quotationId={selectedOrderForUpload?.quotation_id}
// 				onUploadSuccess={() => {
// 					handleCloseUploadPO();
// 					fetchOrders();
// 				}}
// 			/>
// 		</div>
// 	);
// };

// export default ConfirmOrderSeller;

import React, { useState, useEffect } from "react";
import "../../components/DashboardModule/MyQuotations.css";
import UpdateStatusModal from "./UpdateStatusModal";
import { getSellerMyConfirmOrder } from "../../API/Api";
import { MoreVertical } from "lucide-react";
import PendingQuotesDetails from "./PendingQuotesDetails";
import UploadPO from "./UploadPO";

const ConfirmOrderSeller = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isUploadPOOpen, setIsUploadPOOpen] = useState(false);
	const [orders, setOrders] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [selectedEnquiry, setSelectedEnquiry] = useState(null);
	const [showDetails, setShowDetails] = useState(false);
	const [selectedOrderForUpdate, setSelectedOrderForUpdate] = useState(null);
	const [selectedOrderForUpload, setSelectedOrderForUpload] = useState(null);

	const fetchOrders = async () => {
		try {
			const response = await getSellerMyConfirmOrder();
			if (response.status && response.data) {
				setOrders(response.data);
			}
		} catch (err) {
			setError(err.message || "Failed to fetch orders");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchOrders();
	}, []);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};

	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	const handleOpenUploadPO = () => {
		setIsUploadPOOpen(true);
	};

	const handleCloseUploadPO = () => {
		setIsUploadPOOpen(false);
	};

	const handleOpenClick = (enquiry) => {
		setSelectedEnquiry(enquiry);
		setShowDetails(true);
	};

	const handleBackClick = () => {
		setShowDetails(false);
	};

	const handleUpdateStatusClick = (order) => {
		setSelectedOrderForUpdate(order);
		setIsModalOpen(true);
	};

	const handleUploadPOClick = (order) => {
		setSelectedOrderForUpload(order);
		setIsUploadPOOpen(true);
	};

	if (loading) {
		return <div className="quo-container font-poppins">Loading...</div>;
	}

	if (error) {
		return <div className="quo-container font-poppins">Error: {error}</div>;
	}
	if (showDetails && selectedEnquiry) {
		return (
			<PendingQuotesDetails
				onBack={handleBackClick}
				enquiry={selectedEnquiry}
				enquiryId={selectedEnquiry.enquiry_id}
			/>
		);
	}

	return (
		<div className="quo-container font-poppins">
			<div className="quo-header">
				<h2 className="quo-title">Confirmed Orders</h2>
				<div className="quo-actions"></div>
			</div>

			<table className="quo-table">
				<thead>
					<tr>
						<th>Order Id</th>
						<th>Product Details</th>
						<th>Brand Name</th>
						<th>Date</th>
						<th>Status</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					{orders.map((order) => (
						<tr key={order.enquiry_id}>
							<td>{order.order_id}</td>
							<td>
								<div className="product-details">
									<div className="product-name">
										{order.product_details?.product_name || "N/A"}
									</div>
								</div>
							</td>
							<td>
								{order.brands && order.brands.length > 0 ? (
									order.brands.map((brand, index) => (
										<span key={brand.id}>
											{brand.name}
											{index < order.brands.length - 1 && ", "}
										</span>
									))
								) : (
									"...."
								)}
							</td>
							<td>
								{order.product_details?.created_at
									? new Date(order.product_details.created_at).toLocaleDateString()
									: "N/A"}
							</td>
							<td>{order.tracking_status || "N/A"}</td>
							<td>
								<div className="quo-action-menu">
									<MoreVertical />
									<div className="quo-dropdown">
										<button
											className="text-quo font-poppins"
											onClick={() => handleOpenClick(order)}
										>
											Preview
										</button>
										<button
											className="text-quo font-poppins"
											onClick={() => handleUpdateStatusClick(order)}
										>
											Update Status
										</button>
										<button
											className="text-quo font-poppins"
											onClick={() => handleUploadPOClick(order)}
										>
											Upload PI
										</button>
									</div>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			<UpdateStatusModal
				isOpen={isModalOpen}
				onClose={handleCloseModal}
				quotation_id={selectedOrderForUpdate?.quotation_id}
				onStatusUpdated={fetchOrders}
			/>

			<UploadPO
				isOpen={isUploadPOOpen}
				onClose={handleCloseUploadPO}
				order={selectedOrderForUpload}
				quotationId={selectedOrderForUpload?.quotation_id}
				onUploadSuccess={() => {
					handleCloseUploadPO();
					fetchOrders();
				}}
			/>
		</div>
	);
};

export default ConfirmOrderSeller;